<template>
  <div class="module-box">
    <div class="title-icon"></div>
    <div class="title-box">
      {{ title }}
    </div>
  </div>
</template>
<script>
export default {
  name: "moduleTitle",
  props: {
    title: String
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="scss">
.module-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  .title-icon {
    background-image: linear-gradient(
      to left,
      rgba(169, 254, 255, 0),
      rgba(169, 254, 255, 1)
    );
    // margin-left: 50px;
    height: 20px;
    width: 6px;
    margin-left: 8px;
  }
  .title-box {
    height: 36px;
    text-align: left;
    color: rgb(203, 224, 255);
    line-height: 36px;
    font-size: 16px;
    // background-image: linear-gradient(
    //   to left,
    //   rgba(70, 129, 202, 0),
    //   rgba(69, 132, 210, 1)
    // );
    margin-left: 8px;
    width: 220px;
  }
}
</style>
